import { ERgbaShift } from "rc-js-util";
export function generateLinearRGBRange(min, max, writeTo, colorOffset) {
    const _ERgbaShift = ERgbaShift;
    const rStep = getColorStepSize(min, max, _ERgbaShift.R, writeTo.getLength() - 1);
    const gStep = getColorStepSize(min, max, _ERgbaShift.G, writeTo.getLength() - 1);
    const bStep = getColorStepSize(min, max, _ERgbaShift.B, writeTo.getLength() - 1);
    for (let i = writeTo.getStart(), iEnd = writeTo.getEnd(); i < iEnd; ++i) {
        let color = incrementColorChannel(min, _ERgbaShift.R, rStep * i);
        color = incrementColorChannel(color, _ERgbaShift.G, gStep * i);
        color = incrementColorChannel(color, _ERgbaShift.B, bStep * i);
        writeTo.setValue(i, colorOffset, color);
    }
}
function getColorStepSize(min, max, shift, stepCount) {
    const mask = 0xFF << shift;
    const range = ((max & mask) >>> shift) - ((min & mask) >>> shift);
    return range / stepCount;
}
function incrementColorChannel(color, shift, step) {
    const mask = 0xFF << shift;
    const channel = ((color & mask) >>> shift) + step;
    color &= ~mask;
    return color | (channel << shift);
}
//# sourceMappingURL=generate-linear-rgb-range.js.map